/*CAP-20753(SGP Zone): Added new File instead of App.service.ts 
    - Due to time delay and client related Changes
*/
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


@Injectable()
export class AppConfig {
    public apiUrl: string;
    public apiPath: string;
    public mpsaFlag: string;
    public tokenInterval: number;
    public pageCount:number;
    constructor(private http: HttpClient) {}

    load(url:string):Promise<any> {
        const promise = this.http.get(url)
        .toPromise()
        .then(data => {
          Object.assign(this, data);
          return data;
        });

      return promise;
    }

  
}